import React, { useState, useEffect } from 'react';

import CssBaseline from '@material-ui/core/CssBaseline';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import NavMenu from 'components/NavMenu';
import Paper from '@material-ui/core/Paper';
import TextEvents from 'app/components/TextEvents';
import { Table, Drawer, Button, Modal, Spin, Select, Upload, Icon, Radio } from 'antd'
import { useStyles, styles } from './KuCatalogueScreenStyles';
import { useDispatch, useSelector } from 'react-redux';
import ApiService from 'app/services/ApiService';

import * as KUCatalogueActions from '../../actions/KUCatalogueActions'
import *  as SystemActions from '../../actions/SystemActions';
import FilterScreen from './components/Filter';
import { Grid } from '@material-ui/core';
import TextInput from '../../components/TextInput';
import { debounce } from 'debounce';
import TableScreen from './components/Table';
import { message } from "antd";
import { KUCatalogueReducer } from 'app/reducers/KUCatalogueReducer';
//import TableScreen from './TableComponent/TableComponent';


export default function KUCatalogueScreen(props) {
    const { siteId } = useSelector(state => state.Auth)
    const { confirm } = Modal;
    const classes = useStyles();
    const dispatch = useDispatch();
    const [visibleModal, setVisibleModal] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [deletedKU, setdeletedKU] = useState();
    const [showDelete, setShowDelete] = useState(false);

    const { listAllKeyUser } = useSelector(state => state.SystemReducer)

    const { listAllEmployees } = useSelector(state => state.KUCatalogueReducer)


    const [height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });

    const submit = () => {

        let person = listAllEmployees.find(item => item.employeeId === selectedCategory);
        let payload = {
            "idEmployee": selectedCategory,
            "name": person?.name
        }
        setIsSaving(true);
        ApiService.postNewKeyUser(payload).then(
            res => {
                setIsSaving(false);
                setVisibleModal(false);
                dispatch(KUCatalogueActions.getKeyUsers({
                    offset: 0,
                    limit: 25,
                    sortDir: "asc",
                    sortColumn: "name",
                    Name: "",
                    IdEmployee: ""
                }));
            }
        ).catch(
            (error) => {
                message.error(error.response.message);
                setIsSaving(false);
            }
        )
    }

    const openDelete = (data) => {
        // setdeletedKU(data);
        //setShowDelete(true);
        confirm({
            title: '¿Eliminar KeyUser?',
            content: data.name,
            okText: 'Eliminar',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                dispatch(KUCatalogueActions.deleteKeyUser(data.idEmployee, updateTable))
            },
            onCancel() { },
        });
    }

    const updateTable = (value = "") => {
        dispatch(KUCatalogueActions.getKeyUsers({
            offset: 0,
            limit: 25,
            sortDir: "asc",
            sortColumn: "name",
            Name: value,
            IdEmployee: ""
        }));
    }

    const handleGetEmpleados = (value = "") => {
        if(value === "" || value === null) return "";
        dispatch(KUCatalogueActions.getEmployeesForKU({
            Name: value,
            Offset: 0,
            SortColumn: "name",
            SortDir: "asc"
        }))
    }

    useEffect(() => {
        dispatch(KUCatalogueActions.getKeyUsers({
            offset: 0,
            limit: 25,
            sortDir: "asc",
            sortColumn: "name",
            Name: "",
            IdEmployee: ""
        }));
        dispatch(SystemActions.getAllKeyUsers());

    }, [dispatch]);

    const optionsUsers = listAllKeyUser?.map(item => (
        <Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>
    ))

    const optionsUsers2 = listAllEmployees?.map(item => (
        <Select.Option key={item.employeeId} value={item.employeeId}>{item.name}</Select.Option>
    ))

    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} isCatalog={true} header='Key User' isCommunicationStatus={false} />
            <CssBaseline />
            <div className={classes.content}>
                <Modal
                    destroyOnClose={true}
                    onCancel={() => setVisibleModal(false)}
                    visible={visibleModal}
                    title={<TextEvents
                        text={'Nuevo Key User'}
                        color='cotemar'
                        size='label'
                        weight='bold'
                    />}
                    width={'650px'}
                    centered={true}
                    footer={[
                        <Button key="back" type="danger" ghost onClick={() => setVisibleModal(false)}>
                            Cancelar
                        </Button>,
                        siteId === "HUB" ?
                            <Button disabled={selectedCategory === '' || selectedCategory == null} key="submit" type="primary" loading={isSaving} onClick={() => submit()}>
                                Confirmar
                            </Button> : null,
                    ]}
                >
                    <Spin spinning={isSaving}>
                        <Grid container>
                            <Grid item xs={12}>

                                {/* <TextInput
                                    value={selectedCategory}
                                    setValue={setSelectedCategory}
                                    text='Nombre:'
                                    color='darker'
                                    size='label'
                                    weight='medium'
                                    mode='input'
                                    placeholder='Escriba el nombre'
                                    disabled={false}
                                /> */}
                                <TextEvents
                                    text='Nombre:'
                                    color="darker"
                                    size='label'
                                    weight="medium"
                                />
                                <Select
                                    placeholder="[Selecionar Personal]"
                                    showSearch
                                    onChange={setSelectedCategory}
                                    style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                    optionFilterProp="Children"
                                    onSearch={handleGetEmpleados}
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {optionsUsers2}
                                </Select>
                            </Grid>
                        </Grid>
                    </Spin>
                </Modal>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label='Breadcrumb'>
                        <Link color='inherit' disabled>
                            Catálogos
                        </Link>
                        <TextEvents
                            text={'Key Users'}
                            color='cotemar'
                            size='subtitle'
                            weight='bold'
                        />
                    </Breadcrumbs>
                    <Paper className={classes.rootPaper}>
                        <FilterScreen
                            setVisibleModal={setVisibleModal}
                        ></FilterScreen>
                        <TableScreen openDelete={openDelete} dtsize={{ x: 'min-content', y: (height - 430) }}></TableScreen>
                    </Paper>
                </div>
            </div>
        </div>
    )
}